import { H6, Text } from "@adfenix/alexandria";
import { TemplateUiModel } from "routes/back-office/program-builder/details/campaign/meta/template/TemplateUiModel";
import { Row, Col } from "react-grid-system";
import styled from "styled-components";

interface Props {
  template: TemplateUiModel & { type: "image" };
}

const StyledImage = styled.img`
  width: 200px;
  height: 150px;
`;

export const ImageTemplateContent = ({ template }: Props) => {
  return (
    <Row>
      <Col xs="content">
        <StyledImage src={template.previewUrl} />
      </Col>
      <Col>
        <H6>Template url</H6>
        <Text style={{ overflowWrap: "break-word" }}>
          {template.templateUrl}
        </Text>
      </Col>
    </Row>
  );
};
